import './dialogs.scss';
import './confirmDialog.scss';

import * as _ from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { StM, ActM } from '../../modules';
import { Modal } from '../../components';

interface IConfirmDeleteBasketItemDialogProps {
    isShown: boolean;
    basketIndex: number;
    isPackage: boolean;

    closeDialog: () => void;
    removeSessionItem: (id: number) => void;
    removePackageItem: (id: number) => void;
}

interface IConfirmDeleteBasketItemState {}

class ConfirmDeleteBasketItemDialog extends React.Component<IConfirmDeleteBasketItemDialogProps, IConfirmDeleteBasketItemState> {
    constructor(props: IConfirmDeleteBasketItemDialogProps) {
        super(props);
    }

    closeClick(e:any) {
        if(e) {e.stopPropagation();}
        this.props.closeDialog();
    }

    deleteClick(e:any) {
        if(e) {e.stopPropagation();}
        if(this.props.isPackage) {
            this.props.removePackageItem(this.props.basketIndex);
        }
        else {
            this.props.removeSessionItem(this.props.basketIndex);
        }
        this.props.closeDialog();
    }
    
    render() {
        if (this.props.isShown) {
            return (
                <Modal classes="confirmation-delete-dialog" closeHandler={this.props.closeDialog} dialogName={StM.DialogNames.ConfirmDeleteBasketItem}>
                    <div className="modal-dialog dialog">
                        <div className="modal-dialog-header">
                            <div className="title">Are you sure you want to delete the {this.props.isPackage ? 'package' : 'session'}?</div>
                        </div>
                        <div className="modal-dialog-body">
                            <div className="btns-wrapper">
                                <div className="left-btn-wrapper">
                                    <button onClick={(e) => this.deleteClick(e)}>delete</button>
                                </div>
                                <div className="right-btn-wrapper">
                                    <button onClick={(e) => this.closeClick(e)}>cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: StM.IGlobalStoreState, ownProps: any) => {
    let dialog = state.dialogs.confirm;
    return {
        isShown: dialog.isOpened,
        basketIndex: dialog.basketIndex,
        isPackage: dialog.isPackage
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        closeDialog: () => dispatch(ActM.DialogActions.close(StM.DialogNames.ConfirmDeleteBasketItem)),
        removeSessionItem: (id: number) => (dispatch(ActM.BasketActions.remove(id))),
        removePackageItem: (id: number) => (dispatch(ActM.BasketActions.removePackage(id)))
    };

}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmDeleteBasketItemDialog);
